export function enumToArray(enumObj: any): Array<{ key: string; value: string }> {
  return Object.keys(enumObj)
    .filter((key) => isNaN(Number(key))) // Filter out numeric keys
    .map((key) => ({ key, value: enumObj[key] }));
}

export function enumValues(enumObj: any): Array<string> {
  return enumToArray(enumObj).map((entry) => entry.value);
}
